module.exports = __webpack_public_path__ + "static/img/1-1.f25070c.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/6/1-1.png
// module id = 255
// module chunks = 0